<template>
  <div class="field">
    <div class="label">验证码</div>
    <div class="value">
      <input
        class="txr-asterisk"
        type="text"
        :value="value"
        @input="onInput"
        placeholder="请输入验证码"
      />
    </div>
    <div class="code">
      <button class="btn-code"
        :class="status"
        :disabled="status !== 'enabled'"
        @click="onClick"
      >
        {{ text }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    status: String,
    request: Function,
  },
  data() {
    return {
      seconds: 60,
    };
  },
  computed: {
    text() {
      const status = this.status;

      if (status === "countdown") {
        return this.seconds + "s获取验证码";
      }

      return "发送验证码";
    }
  },
  created() {
    this.timer = -1;
    this._status = this.status;
    this.forcedStatus = "";
  },
  destroyed() {
    clearInterval(this.timer);
  },
  watch: {
    status(n) {
      // forcedStatus存在时如果外部想修改, 会被重置回去, 缓存外部想修改的值, forcedStatus清空时重置回去
      if (this.forcedStatus && n !== this.forcedStatus) {
        this._status = n;
        this.$emit("update:status", this.forcedStatus);
      }
    }
  },
  methods: {
    onClick() {
      this.$emit("click", this.status);
      // 启用时发请求
      if (this.status === "enabled") {
        // 同步更新_status
        this._status = "enabled";
        this.request()
          .then(
            () => {
              this.setForcedStatus("countdown");

              this.timer = setInterval(() => {
                if (this.seconds == 0) {
                  this.reset();
                } else {
                  this.seconds--;
                }
              }, 1000);
            }),
            () => {
              this.reset();
            }
          ;
      }
    },
    onInput(event) {
      this.$emit("input", event.target.value);
    },
    reset() {
      this.seconds = 60;
      this.clearForcedStatus();
      clearInterval(this.timer);
    },
    setForcedStatus(value) {
      this.forcedStatus = value;
      this.$emit("update:status", value);
    },
    clearForcedStatus() {
      this.forcedStatus = "";
      this.$emit("update:status", this._status);
    },
  }
}
</script>

<style scoped>
.btn-code {
	width: 0.85rem;
	height: 0.3rem;
	line-height: 0.3rem;
	font-size: 0.11rem;
	border-radius: 0.04rem;
	background: #bfbfbf;
  border: 0;
  outline: none;
  color: #fff;
}
.enabled {
  background-color: #0682c8;
}
.disabled,
.countdown {
  background: #bfbfbf;
}
input {
  text-align: left;
}
</style>